import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import moment from "moment-timezone";

const firebaseConfig = {
    apiKey: "AIzaSyAr-uNbcpDoOBQghaCOBU5z_tue1YVbWNw",
    authDomain: "bizbabyapp-e757e.firebaseapp.com",
    projectId: "bizbabyapp-e757e",
    storageBucket: "bizbabyapp-e757e.firebasestorage.app",
    messagingSenderId: "797965970734",
    appId: "1:797965970734:web:5c90f453ccc19eb84ddebf",
    measurementId: "G-PNEXM0JDBB"
};

export default class FcmNotify{
    static #app;
    static #messaging;
    static #isInit = false
    static #VAPID = 'BCkTGB1malQrPa67AreGmcrCTTXD55Jr7UqT8rVgv9o89T7ta9qRwZD46isOjgwvHWsh-5ewbSJBScnpn1W60K0'
    static #TOKEN = null
    static #prevTitle = ''
    static #timeout = null
    static #popupTimeout = null
    static #workerChannel = null
    static #activeCockpitWindow
    static #checkActiveTokenInterval = null
    static #pageKey
    static #TYPES={
        WAKE_UP:1,
        INCOMING_CALL:2,
        DECLINE_CALL:3,
        MESSAGE:4,
        ADVERT:5,
        CHANGE_PERMISSION:6,
        AVAILABLE_CALL:7,
        CHANGE_USER_ACTIVE:8,
    }

    static #DEVICE_TYPES = {
        PC:1,
        PHONE:2
    }

    static get isInit(){
        return this.#isInit
    }

    static get messaging(){
        return this.#messaging
    }

    static get app(){
        return this.#app
    }

    static get TYPES(){
        return this.#TYPES
    }

    static get DEVICE_TYPE(){
        return this.#DEVICE_TYPES
    }

    static get TOKEN(){
        return this.#TOKEN ? this.#TOKEN : localStorage.getItem('firebaseToken')
    }
    
    static async init(){
        if(this.#isInit)
            return
        const customerVerified = document.querySelector('meta[name=customer-verified]'); //отключение для кастомер кабинета чтоб не было ошибок
        if(customerVerified)
            return
        const request = await fetch(`${location.origin}/check-call-permission`);
        const response = await request.json();
        const resolved = response?.success && response?.resolved;
        if('Notification' in window && window.organisation_id && resolved){
            this.#workerChannel = new BroadcastChannel('serviceChannel');
            this.#workerChannel.onmessage = (ev)=>{
                console.log('SEND DATA FROM SERVICE WORKER:', ev.data)
                if(ev?.data?.type == 'accept-call' && ev?.data?.id){
                    if(this.#activeCockpitWindow && typeof this.#activeCockpitWindow?.close == 'function' && window.name!='parent-cockpit_'+ev?.data?.id){
                        this.#activeCockpitWindow.close()
                        this.#activeCockpitWindow = null
                        window.name = ''
                    }
                }else if(ev?.data?.type == 'background-message' && ev?.data?.notify){
                    const notify = ev?.data?.notify
                    switch(Number(notify?.type)){
                        case FcmNotify.TYPES.INCOMING_CALL:
                            this.showIncomingCallNotify(notify)
                            localStorage.setItem('activeNotify', JSON.stringify(notify))
                            break
                        case FcmNotify.TYPES.DECLINE_CALL:
                            this.hideIncomingCallNotify()
                            break
                    }
                }
            }
            this.setAdditionalHandlers()
            this.#app = initializeApp(firebaseConfig);
            this.#messaging = getMessaging(this.#app);
            const browser = this.detectBrowser()
            if((browser == 'Firefox' || browser == 'Safari') && Notification.permission != 'granted' && !localStorage.getItem('isReqPermissionNotify')){
                if($('#notify-permissions-modal').length){
                    $('#notify-permissions-modal').modal('show')
                    $('#notify-permissions-modal #decline-permission').off('click').on('click', ()=>{
                        console.warn("Notification permission denied!")
                        $('#notify-permissions-modal').modal('hide')
                        localStorage.setItem('isReqPermissionNotify', '1')
                    })
                    $('#notify-permissions-modal #accept-permission').off('click').on('click', ()=>{
                        $('#notify-permissions-modal').modal('hide')
                        localStorage.setItem('isReqPermissionNotify', '1')
                        this.subscribe()
                    })
                }
            }else{
                this.subscribe();
            }
        }
    }

    static setNavCallBtnsClick(){
        $('#quick-call-btn, #call-msg-center-btn').on('click', ev => {
            if(typeof window.name == 'string' && /^parent-cockpit/.test(window.name)){
                let arr = window.name.split('_')
                this.#activeCockpitWindow = window.open('', 'popup-cockpit_'+arr[1]);
                this.#activeCockpitWindow.focus()
                if(ev.currentTarget.id == 'quick-call-btn' && this.#activeCockpitWindow?.document){
                    let modal = $(this.#activeCockpitWindow.document.body).find('#quick-call-modal')
                    if(modal.length)
                        modal.modal('show') 
                }
            }else{
                this.setCockpitPopupActiveCallback()
                let key = this.randKey()
                window.name="parent-cockpit_"+key
                if(ev.currentTarget.id == 'call-msg-center-btn'){
                    this.#activeCockpitWindow = window.open(`${window.location.origin}/cockpit`, 'popup-cockpit_'+key);
                }else{
                    this.#activeCockpitWindow = window.open(`${window.location.origin}/cockpit`, 'popup-cockpit_'+key, `width=435,height=880,left=${screen.width-470},top=${(screen.height-880)/2-20},toolbar=no,resilocation=no,menubar=no,status=no,popup=yes,resizable=no`);
                }
                this.#workerChannel.postMessage({type:'accept-call', id:key})
                if(ev.currentTarget.id == 'quick-call-btn' && this.#activeCockpitWindow?.document){
                    this.#activeCockpitWindow.addEventListener('load',(ev)=>{
                        setTimeout(()=>{
                            if(typeof this.#activeCockpitWindow?.showQuickCall === 'function')
                                this.#activeCockpitWindow?.showQuickCall()
                        },500)
                    }, false)
                }
            }
        })
        $('#available-switch-btn').on('click', function () {
            $('#available-toggle').prop('checked', !$('#available-toggle').prop('checked'))
            if($('#call-toggle').length){
                $('#call-toggle').prop('checked', $('#available-toggle').is(':checked'))
                $('#call-toggle').trigger('click')
            }else{
                let data = $('#available-toggle').is(':checked') 
                ? { type: 'call+forward', status: 'online', fcm_token: FcmNotify.TOKEN}
                : { status: 'offline', fcm_token: FcmNotify.TOKEN}
                $.ajax({
                    type: 'POST',
                    url: '/cockpit/org-update-support-time',
                    data: data
                }).fail(function (jqXHR, exception) {
                    $('#available-toggle').prop('checked', !$('#available-toggle').prop('checked'))
                });
            }
            if($('#available-toggle').is(':checked')){
                $('.dropdown-call-counter').removeClass('d-none')
                $('.not-available-icon').addClass('d-none')
            }else{
                $('.dropdown-call-counter').addClass('d-none')
                $('.not-available-icon').removeClass('d-none')
            }
        });
    }

    static detectBrowser() {
        const userAgent = navigator.userAgent.toLowerCase();
        if (userAgent.indexOf('firefox') != -1) {
            return 'Firefox';
        } else if (userAgent.indexOf('chrome') != -1) {
            return 'Chrome';
        } else if (userAgent.indexOf('safari') != -1) {
            return 'Safari';
        } else if (userAgent.indexOf('opera') != -1 || userAgent.indexOf('opr') != -1) {
            return 'Opera';
        } else if (userAgent.indexOf('msie') != -1 || userAgent.indexOf('trident') != -1) {
            return 'Internet Explorer';
        } else {
            return 'Unknown';
        }
    }

    static async setNoActiveServerToken(){
        const token = localStorage.getItem('firebaseToken');
        if(token && window?.organisation_id && window?.user_id){
            $.ajax({
                url: `${location.origin}/set-no-active-fcm-token`,
                method: 'POST',
                dataType: 'json',
                data: {
                    fcm_token:token,
                    organisation_id:window.organisation_id,
                    user_id:window.user_id
                },  
                success: response=>{
                    if(response?.success)
                        console.log('SET NO ACTIVE SERVER FCM_TOKEN')
                },
                error: err=>{
                    console.error(err)
                }
            }); 
        }
    }

    static setCockpitPopupActiveCallback(){
        window.setActiveCockpitPopup = (active, key)=>{
            if(active){
                let arr = key.split('_')
                window.name = 'parent-cockpit_'+arr[1]
                this.#activeCockpitWindow = window.open('', key);
                this.#activeCockpitWindow.blur()
                window.focus()
                console.log('ACTIVE POPUP')
            }else{
                this.#activeCockpitWindow = null
                window.name = ''
                console.log('DISACTIVE POPUP')
            }
        }
    }

    static setCockpitParentActiveCallback(){
        window.setActiveCockpitParent = (active) => {
            if(active)
                clearTimeout(this.#popupTimeout)
            else
                this.#popupTimeout = setTimeout(()=>window.close(),10000)
        }
    }

    static setShowQuickCall(){
        window.showQuickCall = () =>{
            let modal = $(document.body).find('#quick-call-modal')
            if(modal.length)
                modal.modal('show')
        }
    }

    static setAcceptCallHandler(){
        window.acceptCallHandler = (data, identity) =>{
            console.log('DATA CALLERS:', data)
            console.log('IDENTITY: ', identity)
            const btn = $('#queue-call-list').find(`.btn.call-modal[data-identity=${identity}]`)
            if(btn.length){
                btn.trigger('click')
                setTimeout(()=>{
                    console.log("CLICK ACCEPT CALL")
                    $('#modal-call .wait-call').trigger('click')
                },1000)
            }
        }
    }

    static randKey(){
        return (Math.random()+1).toString(36)
    }

    static async subscribe() {
        try{
            const permission = await Notification.requestPermission();
            if(permission === 'granted'){
                console.log('GET TOKEN')
                const token = await getToken(this.#messaging, { vapidKey: this.#VAPID })
                console.log('END GET TOKEN')
                if(token){
                    this.#TOKEN = token
                    console.log(token)
                    localStorage.setItem('firebaseToken',token);
                    if(window?.organisation_id)
                        this.sendTokenToServer(token)
                    this.#isInit = true;
                    this.setOnMessage()
                    this.setNavCallBtnsClick()
                }else{
                    throw new Error("Couldn't get a firebase token")
                }
            }else{
                console.warn("Notification permission denied!")
            }
        }catch(err){
            FcmNotify.funcChangeBtns('denied', true)
            $('#call-btn-notify-declined').attr('data-placeholder', 'The notification service was not started.')
            console.error(err)
        }
    }

    static showIncomingCallNotify(notify){
        if($('#call-notify').length){
            $('#call-notify #accept-call-btn').data('identity', notify?.identity)
            $('#call-notify #decline-call-btn').data('identity', notify?.identity)
            $('#call-notify .call-notify-text').text(`Contact: ${notify?.fromPhone}`)
            $('#call-notify').removeClass('d-none').addClass('show')
            $('#call-notify #notify-sound')[0].play()
            clearInterval(this.#timeout)
            this.#prevTitle = document.title;
            this.#timeout = setInterval(()=>{
                if(document.title != '***INCOMING CALL***')
                    document.title='***INCOMING CALL***'
                else
                    document.title='*******************'
            },1000)  
        }else{
            console.error(`CALL NOTIFY BLOCK DOESN'T EXIST!`)
        }
    }

    static hideIncomingCallNotify(){
        if($('#call-notify').length){
            $('#call-notify').removeClass('show')
            setTimeout(()=>{
                $('#call-notify').addClass('d-none')
            },500)
        }
        clearInterval(this.#timeout)
        if(this.#prevTitle.length)
            document.title = this.#prevTitle
        this.#prevTitle = ''
        localStorage.removeItem('activeNotify')
    }

    static async rejectCallNotify(identity){
        let request = await fetch(`${location.origin}/cockpit/reject-call`, {
            method: 'POST',
            body: JSON.stringify({
                identity
            }),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        })
        const result = await request.json();
        return result?.success ? true : false
    }

    static setOnMessage(){
        try{
            if(!this.#isInit)
                throw new Error("Fcm notify has not been initialized!")
            $('#call-notify #decline-call-btn').on('click',ev=>{
                this.hideIncomingCallNotify()
                this.rejectCallNotify($(ev.currentTarget).data('identity'))
            })
            $('#call-notify #hide-call-btn').on('click',()=>{
                this.hideIncomingCallNotify()
            })
            $('#call-notify #accept-call-btn').on('click',ev=>{
                const btn = $(ev.currentTarget)
                const updateHandler = event =>{
                    console.log("ACTIVE HANDLER: ", this.#activeCockpitWindow?.acceptCallHandler === 'function')
                    if(!(typeof this.#activeCockpitWindow?.acceptCallHandler === 'function'))
                        return
                    this.#activeCockpitWindow.removeEventListener('update-new-calls', updateHandler)
                    this.#activeCockpitWindow.acceptCallHandler(event.detail, btn.data('identity'))
                }
                if(typeof window.name == 'string' && /^parent-cockpit/.test(window.name)){
                    let arr = window.name.split('_')
                    this.#activeCockpitWindow = window.open('', 'popup-cockpit_'+arr[1]);
                    this.#activeCockpitWindow.focus()
                    this.#activeCockpitWindow.addEventListener('update-new-calls', updateHandler)
                }else{
                    this.setCockpitPopupActiveCallback()
                    let key = this.randKey()
                    window.name="parent-cockpit_"+key
                    this.#activeCockpitWindow = window.open(`${window.location.origin}/cockpit`, 'popup-cockpit_'+key, `width=435,height=880,left=${screen.width-470},top=${(screen.height-880)/2-20},toolbar=no,resilocation=no,menubar=no,status=no,popup=yes,resizable=no`);
                    this.#workerChannel.postMessage({type:'accept-call', id:key})
                    this.#activeCockpitWindow.addEventListener('update-new-calls', updateHandler)
                }
                this.hideIncomingCallNotify()
            })
            onMessage(this.#messaging, notify=>{
                console.log("NOTIFICATION: ", notify)
                switch(Number(notify?.data?.type)){
                    case FcmNotify.TYPES.INCOMING_CALL:
                        this.showIncomingCallNotify(notify?.data)
                        localStorage.setItem('activeNotify', JSON.stringify(notify?.data))
                        break
                    case FcmNotify.TYPES.DECLINE_CALL:
                        this.hideIncomingCallNotify()
                        break
                }
            })
            console.log('SET ON MESSAGE')
            return true
        }catch(err){
            console.error(err)
            return false
        }
    }

    static funcChangeBtns(state, isChange = false) {
        console.log('STATE: ', state)
        if (state == 'granted') {
            $('#call-btn-notify-declined').addClass('d-none')
            $('#dropdown-call-btn').removeClass('d-none')
            if ($('#available-toggle').is(':checked')) {
                $('.dropdown-call-counter').removeClass('d-none')
                $('.not-available-icon').addClass('d-none')
            } else {
                $('.dropdown-call-counter').addClass('d-none')
                $('.not-available-icon').removeClass('d-none')
            }
        } else {
            $('#call-btn-notify-declined').removeClass('d-none')
            $('#dropdown-call-btn').addClass('d-none')
            $('.dropdown-call-counter').addClass('d-none')
            $('.not-available-icon').addClass('d-none')
        }
        if (isChange && state == 'denied') {
            FcmNotify.setNoActiveServerToken()
            localStorage.removeItem('isSendToken')
        }
    }

    static setAdditionalHandlers(){
        const identifiers = [
            '#logout-btn',
            '.switch-company-menu-row',
            '#select-org-btn'
        ]
        for(let id of identifiers){
            if($(id).length)
                $(id).on('click',()=>{
                    FcmNotify.setNoActiveServerToken()
                    localStorage.removeItem('isSendToken')
                    console.log('DELETE IS SEND TOKEN')
                })
        }
        try{
            let activeNotify = localStorage.getItem('activeNotify')
            if (activeNotify) {
                activeNotify = JSON.parse(activeNotify)
                console.log('ACTIVE NOTIFY: ', activeNotify)
                this.showIncomingCallNotify(activeNotify)
            }
        }catch(err){
            console.error(err)
        }
        window.addEventListener('storage', event =>{
            if(event.storageArea != localStorage) return
            if(event.key == 'activeNotify' && event.newValue == null)
                this.hideIncomingCallNotify()
            if(event.key == 'availableCall' && event.newValue!=null){
                if($('#available-toggle').length)
                    $('#available-toggle').prop('checked', event.newValue == '1')
                if($('#call-toggle').length)
                    $('#call-toggle').prop('checked', event.newValue == '1')
            }
            if(event.key == 'setCheckActiveTokenInterval' && event.newValue == this.#pageKey){
                console.log('SET CHECK ACTIVE TOKEN INTERVAL WITH MY KEY')
                clearInterval(this.#checkActiveTokenInterval)
                this.#checkActiveTokenInterval = setInterval(() => {
                    let lifetime = getCookie('bizbaby_session_lifetime')
                    if (lifetime === undefined || (!isNaN(Number(lifetime)) && moment().unix() >= Number(lifetime))) {
                        FcmNotify.setNoActiveServerToken()
                        localStorage.removeItem('isSendToken')
                    }
                    console.log('TICK INTERVAL')
                }, 5000)
            }
        })
        window.addEventListener('load',()=>{
            let instances = localStorage.getItem('instances')
            instances = instances ? Number(instances) : 0
            instances = instances < 0 ? 0 : instances
            localStorage.setItem('instances',  instances+1 )
            if(/^\/cockpit/.test(location.pathname)){
                instances = localStorage.getItem('callCenterInstances')
                instances = instances ? Number(instances)+1 : 1
                localStorage.setItem('callCenterInstances',  instances)
            }
            if(typeof window.name == 'string' && /^parent-cockpit/.test(window.name)){
                this.setCockpitPopupActiveCallback()
                let arr = window.name.split('_')
                this.#activeCockpitWindow = window.open('', 'popup-cockpit_'+arr[1]);
                this.#activeCockpitWindow.blur()
                window.focus()
                if(this.#activeCockpitWindow && typeof this.#activeCockpitWindow.setActiveCockpitParent == 'function'){
                    this.#activeCockpitWindow.setActiveCockpitParent(true)
                }
            }
            if(typeof window.name == 'string' && /^popup-cockpit/.test(window.name)){
                this.setCockpitParentActiveCallback()
                this.setShowQuickCall()
                this.setAcceptCallHandler()
                if(typeof window?.opener?.setActiveCockpitPopup=='function'){
                    window.opener?.setActiveCockpitPopup(true, window.name)
                }
            }
        })
        window.addEventListener('beforeunload',(ev)=>{
            let instances = localStorage.getItem('instances')
            if (instances) {
                instances = Number(instances) - 1;
                instances = instances < 0 ? 0 : instances
                localStorage.setItem('instances',  instances)
                if (instances===0){
                    console.log('ALL_PAGES_CLOSED')
                    this.setNoActiveServerToken()
                    localStorage.removeItem('isSendToken')
                } 
            }
            if(/^\/cockpit/.test(location.pathname)){
                instances = localStorage.getItem('callCenterInstances')
                instances = instances ? Number(instances)-1 : 0
                instances = instances < 0 ? 0 : instances
                localStorage.setItem('callCenterInstances',  instances)
            }
            if(typeof window.name == 'string' && /^parent-cockpit/.test(window.name)){
                console.log(this.#activeCockpitWindow)
                if(this.#activeCockpitWindow && typeof this.#activeCockpitWindow.setActiveCockpitParent == 'function'){
                    this.#activeCockpitWindow.setActiveCockpitParent(false)
                }
            }
            if(typeof window.name == 'string' && /^popup-cockpit/.test(window.name)){
                if(typeof window?.opener?.setActiveCockpitPopup=='function'){
                    window.opener?.setActiveCockpitPopup(false, window.name)
                }
            }
            let keys = localStorage.getItem('pageKeys')
            keys = keys ? JSON.parse(keys) : []
            keys = keys.filter(el=>el!=this.#pageKey)
            localStorage.setItem('pageKeys', JSON.stringify(keys))
            if(this.#checkActiveTokenInterval){
                clearInterval(this.#checkActiveTokenInterval)
                if(keys.length){
                    localStorage.setItem('setCheckActiveTokenInterval', keys[0])
                }else{
                    localStorage.removeItem('setCheckActiveTokenInterval')
                    this.setNoActiveServerToken()
                    localStorage.removeItem('isSendToken')
                }
            }
        })

        FcmNotify.funcChangeBtns(Notification.permission)
        if ('permissions' in navigator) {
            navigator.permissions.query({name:'notifications'}).then(function(permission) {
                permission.onchange = function() {
                    console.log("User decided to change his seettings. New permission: " + permission.state);
                    FcmNotify.funcChangeBtns(permission.state, true)
                };
            });
        }

        const getCookie = name=>{
            let matches = document.cookie.match(new RegExp(
                "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
            ));
            return matches ? decodeURIComponent(matches[1]) : undefined;
        }
        
        this.#pageKey = 'page_'+this.randKey()
        console.log(this.#pageKey)
        let keys = localStorage.getItem('pageKeys')
        keys = keys ? JSON.parse(keys) : []
        keys.push(this.#pageKey)
        localStorage.setItem('pageKeys', JSON.stringify(keys))

        if(!localStorage.getItem('setCheckActiveTokenInterval')){
            localStorage.setItem('setCheckActiveTokenInterval', this.#pageKey)
            clearInterval(this.#checkActiveTokenInterval)
            this.#checkActiveTokenInterval = setInterval(()=>{ 
                let lifetime = getCookie('bizbaby_session_lifetime')
                if(lifetime === undefined || (!isNaN(Number(lifetime)) && moment().unix() >= Number(lifetime))){
                    FcmNotify.setNoActiveServerToken()
                    localStorage.removeItem('isSendToken')
                }
                console.log('TICK INTERVAL')
            },5000)
        }
       
    }

    static async sendTokenToServer(token){
        const isSend = localStorage.getItem(`isSendToken`)
        if(isSend){
            console.log('TOKEN HAS SENDED')
            return
        }
        console.log('SEND TOKEN TO SERVER')
        $.ajax({
            url: `${location.origin}/set-fcm-token`,
            method: 'POST',
            dataType: 'json',
            data: {
                fcm_token:token,
                organisation_id:window.organisation_id,
                device_type: this.#DEVICE_TYPES.PC
            },  
            success: response=>{
                if(response?.success)
                    localStorage.setItem(`isSendToken`, true)
            },
            error: err=>{
                console.error(err)
            }
        }); 
    }
}

